<div class="container-fluid px-0 mt-4">
    <div class="row">
      <div class="col-12 col-lg-5 left-columm-menu">

            <div class="card p-4 border-0 rounded-8 box-shadow">
                <h1 class="blue-0041A3 font-size-24 font-solomon-bold mb-1"><i class="icon-gift mr-2"></i>{{ 'Módulo de momentos' | translate }}</h1>
                <p class="gray-9EACB3 font-solomon font-size-14 mb-4">{{ 'Adquisición de información del campo a través de cuestionarios' | translate }}</p>
                <p class="gray-696969 font-solomon font-size-16 mb-0">
                    {{ 'En este módulo puedes configurar los momentos o eventos a los que se desea hacer seguimiento, a continuación el conjunto de acciones disponibles:' | translate }}
                </p>
            </div>
            <h2 class="blue-0041A3 font-solomon-black font-size-16 my-4">
                {{ 'Acciones disponibles' | translate }}
            </h2>


            <div class="card border-0 box-shadow card-small-menu mb-3 cursor" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" [routerLink]="['/moments/']">
                <div class="row mx-0">
                    <div class="col-2 col-lg-1 d-flex justify-content-center align-items-center icon-left">
                        <i class="icon-gift font-size-18"></i>
                    </div>
                    <div class="col-8 col-lg-9 pl-0">
                        <h3 class="font-solomon-bold font-size-16 mb-0">
                            {{ 'Ver momentos disponibles' | translate }}
                        </h3>
                        <p class="font-solomon font-size-12 mb-0">
                            {{ 'Visualiza los momentos disponibles' | translate }}
                        </p>
                    </div>
                    <div class="col-2 col-lg-2 d-flex justify-content-end align-items-center font-size-24 pr-4 link">
                        <a [routerLink]="['/moments/']"><i class="icon-arrow_right"></i></a>
                    </div>
                </div>
            </div>

            <div class="card border-0 box-shadow card-small-menu mb-3 cursor" routerLinkActive="active" [routerLink]="['/moments/add']">
                <div class="row mx-0">
                    <div class="col-2 col-lg-1 d-flex justify-content-center align-items-center icon-left">
                        <i class="icon-gift font-size-18"></i>
                    </div>
                    <div class="col-8 col-lg-9 pl-0">
                        <h3 class="font-solomon-bold font-size-16 mb-0">
                            {{ 'Agregar nuevo momento' | translate }}
                        </h3>
                        <p class="font-solomon font-size-12 mb-0">
                            {{ 'Permite crear nuevos momentos' | translate }}
                        </p>
                    </div>
                    <div class="col-2 col-lg-2 d-flex justify-content-end align-items-center font-size-24 pr-4 link">
                        <a [routerLink]="['/moments/add']"><i class="icon-arrow_right"></i></a>
                    </div>
                </div>
            </div>

            <div class="card border-0 box-shadow card-small-menu mb-3 cursor" routerLinkActive="active" [routerLink]="['/moments/causals']">
                <div class="row mx-0">
                    <div class="col-2 col-lg-1 d-flex justify-content-center align-items-center icon-left">
                        <i class="icon-gift font-size-18"></i>
                    </div>
                    <div class="col-8 col-lg-9 pl-0">
                        <h3 class="font-solomon-bold font-size-16 mb-0">
                            {{ 'Gestión de causales' | translate }}
                        </h3>
                        <p class="font-solomon font-size-12 mb-0">
                            {{ 'Gestiona las posibles causales' | translate }}
                        </p>
                    </div>
                    <div class="col-2 col-lg-2 d-flex justify-content-end align-items-center font-size-24 pr-4 link">
                        <a [routerLink]="['/moments/causals']"><i class="icon-arrow_right"></i></a>
                    </div>
                </div>
            </div>

            <div class="card border-0 box-shadow card-small-menu mb-3 cursor" routerLinkActive="active" [routerLink]="['/moments/segmentations']">
                <div class="row mx-0">
                    <div class="col-2 col-lg-1 d-flex justify-content-center align-items-center icon-left">
                        <i class="icon-gift font-size-18"></i>
                    </div>
                    <div class="col-8 col-lg-9 pl-0">
                        <h3 class="font-solomon-bold font-size-16 mb-0">
                            {{ 'Asignación de momentos a segmentaciones' | translate }}
                        </h3>
                        <p class="font-solomon font-size-12 mb-0">
                            {{ 'Permite la asignación de momentos' | translate }}
                        </p>
                    </div>
                    <div class="col-2 col-lg-2 d-flex justify-content-end align-items-center font-size-24 pr-4 link">
                        <a [routerLink]="['/moments/segmentations']"><i class="icon-arrow_right"></i></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-7">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
